import { render, staticRenderFns } from "./soldto.vue?vue&type=template&id=de4e3c04&scoped=true"
import script from "./soldto.vue?vue&type=script&lang=js"
export * from "./soldto.vue?vue&type=script&lang=js"
import style0 from "./soldto.vue?vue&type=style&index=0&id=de4e3c04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de4e3c04",
  null
  
)

export default component.exports